import Link from "next/link";
import {Button} from "@mantine/core";
import {Icon} from "@iconify/react";

export default function EmptyCart({compact = false,}) {
    return (
        <div className={
                compact
                    ? 'py-10 text-center'
                    : 'min-h-[60vh] flex flex-col items-center justify-center text-center py-12'
            }
        >
            <div className="mb-4 flex justify-center">
                <div className="rounded-full bg-gray-100 p-5">
                    <svg xmlns="http://www.w3.org/2000/svg" fontSize={compact ? 40 : 70} width="1em" height="1em" viewBox="0 0 24 24" className="text-gray-500">
                        <path d="M0 0h24v24H0z" fill="none" />
                        <g fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
                            <path d="M4 19a2 2 0 1 0 4 0a2 2 0 0 0-4 0" />
                            <path d="M13 17H6V3H4" />
                            <path d="m6 5l14 1l-1 7H6m16 9l-5-5m0 5l5-5" />
                        </g>
                    </svg>
                </div>
            </div>
            <h2 className={compact
                        ? 'text-lg font-medium'
                        : 'text-2xl lg:text-4xl font-semibold'
                }
            >
                Your cart is empty
            </h2>

            <p className="mt-2 text-sm text-gray-500 max-w-md mx-auto">
                Looks like you haven’t added anything to your cart yet.
            </p>

            <div className="mt-6">

                <Link href="/collections">

                    <Button
                        size={compact ? 'sm' : 'md'}
                        tt="uppercase"
                    >
                        Continue Shopping
                    </Button>

                </Link>

            </div>
        </div>
    )
}